import { api } from '@/services/api';
import { isEmbeddedMode } from '@/utils/embedded-console';

/** Longest a console sign-out waits for the server before signing out locally anyway. */
export const CONSOLE_LOGOUT_TIMEOUT_MS = 5_000;

/**
 * Sign-out inside the embedded console (R4-CONSOLE). The server ends THIS
 * console session only (POST /api/auth/logout with a cst=console token
 * revokes its console_sessions row); the device session, and with it the
 * native app and its offline data, stays signed in. Best effort and bounded:
 * the caller signs out locally whatever happens, and the WebView's storage is
 * dropped when the shell closes the console. Does nothing outside embedded
 * mode, where sign-out keeps its existing client-only behaviour.
 *
 * Must run BEFORE the auth store is cleared: the request carries the token.
 */
export async function endEmbeddedConsoleSession(): Promise<void> {
  if (!isEmbeddedMode()) return;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), CONSOLE_LOGOUT_TIMEOUT_MS);
  try {
    await api.post('/auth/logout', undefined, { signal: controller.signal });
  } catch {
    // Offline or already ended: the local sign-out below still happens.
  } finally {
    clearTimeout(timer);
  }
}
